import { render, staticRenderFns } from "./SizesListNew.vue?vue&type=template&id=5a4bd5d4&scoped=true&"
import script from "./SizesListNew.vue?vue&type=script&lang=js&"
export * from "./SizesListNew.vue?vue&type=script&lang=js&"
import style0 from "./SizesListNew.vue?vue&type=style&index=0&id=5a4bd5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4bd5d4",
  null
  
)

export default component.exports